import React,{useState, useContext} from 'react'
import {ButtonLoader} from '../../utils/ButtonLoader';
import PhoneInput from 'react-phone-number-input';
import { isMobile } from "react-device-detect";
import { useFetch } from '../../api/FetchApiData';
import { AppContext } from '../../../AppContextProvider';
if (isMobile)
    import('./form_mob.css').then(() => {});
  else
    import('./form.css').then(() => {});

function InscriptionForm({setNotification = ()=>{},setConFormIsSelected, setUserId}) 
{
    const [data,setData] = useState({'username':'username'});
    const [charteColor,setCharteColor] = useState("black");
    const [colorEmail,setColorEmail] = useState("darkgray");
    const [colorCpass,setColorCpass] = useState("darkgray");
    const [charte,setCharte] = useState(false);
    const [loading,setLoading] = useState(false);
    const [topform,setTopForm] = useState('50%');
    const [AppState,setAppState] = useContext(AppContext);
    const fetchData = useFetch();

    const HandleData=(htmlElement)=>
    {
        if(htmlElement.target.name==='cpassword')
        {
            if(htmlElement.target.value!==data['password'])
                setColorCpass("red");
            else
                setColorCpass("darkgray");
            return;
        }
        else
        {
            data[htmlElement.target.name] = htmlElement.target.value.replace(/'/g,"''");
        }

        if(htmlElement.target.name==='email')
        {
            if(validateEmail(htmlElement.target.value))
            {setColorEmail("red");return}
            else{setColorEmail("red");}
        }
    }

    const HandlePhone=(value,isNumber)=>
    {
        setNotification({"origine":"","value":""});
        if(isNumber)
        {
            data["phone"] = value;
        }
    }

    const validateEmail=(email)=>
    {
        return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    }

    const RegistrationRequest=()=>
    {
        if(charte)
        {
            data['username'] = data['email'];
            fetchData.PostData(data,'user/register/').then((result)=>{
                if(!result.result)
                {
                    setNotification({"origine":'inscription',"value":"exist"});
                }
                else
                {
                    setNotification({"origine":'inscription',"value":"success"});
                    setConFormIsSelected(3);
                    setUserId(result.user_id);
                }
            });
        }
        else
        {
            setCharteColor("red");
        }
    };
  
    return (
        <div className="Form">
            <div className="inputDiv">
                <label>Nom</label>
                <input onChange={e=>{HandleData(e)}} defaultValue={data.name} name="last_name" type="text" placeholder="Votre Nom" />
            </div>
            <div className="inputDiv">
                <label>Prenom</label>
                <input onChange={e=>{HandleData(e)}} defaultValue={data.prenom} name="first_name" type="text" placeholder="Votre Prenom" />
            </div>
            <div className="inputDiv">
                <label>Email</label>
                <input onChange={e=>{HandleData(e)}} name="email" defaultValue={data.email} type="email" placeholder="Votre adress email" />
            </div>
            <div className="inputDiv">
                <label>Télephone</label>
                <div id="inputTel">
                    <PhoneInput name="phone" defaultCountry={'KM'} defaultValue={data.phone} onCountryChange={(e)=>{HandlePhone(e,false)}} placeholder="Enter phone number" onChange={(e)=>{HandlePhone(e,true)}}/>
                </div>
            </div>
            <div className="inputDiv">
                <label>Mot de passe</label>
                <input onChange={e=>{HandleData(e);setNotification({"origine":"password","value":""});}} defaultValue={data.password} name="password" type="password" placeholder="*************" />
            </div>
            <div className="inputDiv">
                <label>Confirmez le Mot de Passe</label>
                <input onChange={e=>{HandleData(e);}} name="cpassword" style={{border: "1px solid "+colorCpass}} type="password" placeholder="*************" />
            </div>
            <div id="inputChart" style={{marginTop:"10px",marginBottom:"10px"}}>
                <input onClick={e=>{setCharte(e.target.checked)}} name="charte" type="checkbox" style={{border:"1px solid "+charteColor,width:'20px',height:'15px'}} /> <label style={{fontSize:'small'}}>J'accepte les <a>conditions</a> d'utilisations de ce service</label>
            </div>
            <div className="btnSubmit" style={{}}>
                <ButtonLoader loading={loading} onSubmit={e=>{RegistrationRequest();}} text={"Envoyer"} style={{backGroundColor:'yellowgreen',fontSize:'small'}} />                    
            </div>
            <input onClick={e=>{setConFormIsSelected(1);setTopForm('100px');}} type="button" className="btnSubmit" style={{backgroundColor:'lightgray'}} value={"Connexion"}></input>
        </div>);
}


export default InscriptionForm
